import Const from 'constants';
import {LineupPlayers} from 'components/organisms/lineup/components/mobile/lineup-players';
import {LineupPlayers as CfbClassicLineupPlayers} from 'components/organisms/lineup/components/mobile/lineup-players/sports/cfb/classic';
import {LineupPlayers as CfbShowDownLineupPlayers} from 'components/organisms/lineup/components/mobile/lineup-players/sports/cfb/showdown';
import {LineupPlayers as CfbSingleGameLineupPlayers} from 'components/organisms/lineup/components/mobile/lineup-players/sports/cfb/single-game';
import {LineupPlayers as MlbClassicLineupPlayers} from 'components/organisms/lineup/components/mobile/lineup-players/sports/mlb/classic';
import {LineupPlayers as MlbShowDownLineupPlayers} from 'components/organisms/lineup/components/mobile/lineup-players/sports/mlb/showdown';
import {LineupPlayers as MlbSingleGameLineupPlayers} from 'components/organisms/lineup/components/mobile/lineup-players/sports/mlb/single-game';
import {LineupPlayers as MlbTiersLineupPlayers} from 'components/organisms/lineup/components/mobile/lineup-players/sports/mlb/tiers';
import {LineupPlayers as NflClassicLineupPlayers} from 'components/organisms/lineup/components/mobile/lineup-players/sports/nfl/classic';
import {LineupPlayers as NflShowDownLineupPlayers} from 'components/organisms/lineup/components/mobile/lineup-players/sports/nfl/showdown';
import {LineupPlayers as NflSingleGameLineupPlayers} from 'components/organisms/lineup/components/mobile/lineup-players/sports/nfl/single-game';
import {LineupPlayers as NflTiersLineupPlayers} from 'components/organisms/lineup/components/mobile/lineup-players/sports/nfl/tiers';
import {LineupPlayers as NhlClassicLineupPlayers} from 'components/organisms/lineup/components/mobile/lineup-players/sports/nhl/classic';
import {LineupPlayers as NhlShowDownLineupPlayers} from 'components/organisms/lineup/components/mobile/lineup-players/sports/nhl/showdown';
import {LineupPlayers as NhlTiersLineupPlayers} from 'components/organisms/lineup/components/mobile/lineup-players/sports/nhl/tiers';
import {LineupPlayers as GolfTiersLineupPlayers} from 'components/organisms/lineup/components/mobile/lineup-players/sports/golf/tiers';
import {LineupPlayers as NbaClassicLineupPlayers} from 'components/organisms/lineup/components/mobile/lineup-players/sports/nba/classic';
import {LineupPlayers as NbaShowDownLineupPlayers} from 'components/organisms/lineup/components/mobile/lineup-players/sports/nba/showdown';
import {LineupPlayers as NbaSingleGameLineupPlayers} from 'components/organisms/lineup/components/mobile/lineup-players/sports/nba/single-game';
import {LineupPlayers as NbaTiersLineupPlayers} from 'components/organisms/lineup/components/mobile/lineup-players/sports/nba/tiers';
import {LineupPlayers as LolClassicLineupPlayers} from 'components/organisms/lineup/components/mobile/lineup-players/sports/lol/classic';
import {LineupPlayers as MmaClassicLineupPlayers} from 'components/organisms/lineup/components/mobile/lineup-players/sports/mma/classic';
import {LineupPlayers as MmaShowDownLineupPlayers} from 'components/organisms/lineup/components/mobile/lineup-players/sports/mma/showdown';
import {LineupPlayers as TennisClassicLineupPlayers} from 'components/organisms/lineup/components/mobile/lineup-players/sports/tennis/classic';
import {LineupPlayers as F1ClassicLineupPlayers} from 'components/organisms/lineup/components/mobile/lineup-players/sports/f1/classic';

const classesMap = {
    [Const.LEAGUE_CFB]: {
        [Const.GAME_TYPE_CLASSIC]: CfbClassicLineupPlayers,
        [Const.GAME_TYPE_SHOWDOWN]: CfbShowDownLineupPlayers,
        [Const.GAME_TYPE_SINGLEGAME]: CfbSingleGameLineupPlayers,
    },
    [Const.LEAGUE_F1]: {
        [Const.GAME_TYPE_CLASSIC]: F1ClassicLineupPlayers,
    },
    [Const.LEAGUE_GOLF]: {
        [Const.GAME_TYPE_CLASSIC]: LineupPlayers,
        [Const.GAME_TYPE_SHOWDOWN]: LineupPlayers,
        [Const.GAME_TYPE_TIERS]: GolfTiersLineupPlayers,
    },
    [Const.LEAGUE_LOL]: {
        [Const.GAME_TYPE_CLASSIC]: LolClassicLineupPlayers,
    },
    [Const.LEAGUE_MMA]: {
        [Const.GAME_TYPE_CLASSIC]: MmaClassicLineupPlayers,
        [Const.GAME_TYPE_SHOWDOWN]: MmaShowDownLineupPlayers,
    },
    [Const.LEAGUE_MLB]: {
        [Const.GAME_TYPE_CLASSIC]: MlbClassicLineupPlayers,
        [Const.GAME_TYPE_SHOWDOWN]: MlbShowDownLineupPlayers,
        [Const.GAME_TYPE_SINGLEGAME]: MlbSingleGameLineupPlayers,
        [Const.GAME_TYPE_TIERS]: MlbTiersLineupPlayers,
    },
    [Const.LEAGUE_NASCAR]: {
        [Const.GAME_TYPE_CLASSIC]: LineupPlayers,
    },
    [Const.LEAGUE_NBA]: {
        [Const.GAME_TYPE_CLASSIC]: NbaClassicLineupPlayers,
        [Const.GAME_TYPE_SHOWDOWN]: NbaShowDownLineupPlayers,
        [Const.GAME_TYPE_SINGLEGAME]: NbaSingleGameLineupPlayers,
        [Const.GAME_TYPE_TIERS]: NbaTiersLineupPlayers,
    },
    [Const.LEAGUE_NFL]: {
        [Const.GAME_TYPE_CLASSIC]: NflClassicLineupPlayers,
        [Const.GAME_TYPE_SHOWDOWN]: NflShowDownLineupPlayers,
        [Const.GAME_TYPE_SINGLEGAME]: NflSingleGameLineupPlayers,
        [Const.GAME_TYPE_TIERS]: NflTiersLineupPlayers,
    },
    [Const.LEAGUE_NHL]: {
        [Const.GAME_TYPE_CLASSIC]: NhlClassicLineupPlayers,
        [Const.GAME_TYPE_SHOWDOWN]: NhlShowDownLineupPlayers,
        [Const.GAME_TYPE_SINGLEGAME]: NhlShowDownLineupPlayers,
        [Const.GAME_TYPE_TIERS]: NhlTiersLineupPlayers,
    },
    [Const.LEAGUE_TENNIS]: {
        [Const.GAME_TYPE_CLASSIC]: TennisClassicLineupPlayers,
    },
};

const Factory = {
    getComponent(sportConfig) {
        const sportName = sportConfig.getSport().toLowerCase();
        const gameType = sportConfig.getGameType().toLowerCase();

        const componentClass = classesMap[sportName]?.[gameType] ?? null;

        if (componentClass === null) {
            throw new Error(`Unsupported factory for "${sportName}", "${gameType}".`);
        }

        return componentClass;
    },
};

export {Factory};
